// 管理端标签页（tags-view）状态管理
// visitedViews: 当前打开的标签列表（持久化到 localStorage）
// cachedViews: keep-alive include 使用的组件 name 列表（由 visitedViews 派生）

const STORAGE_KEY = 'admin_visited_views'

// 标签数量上限（含固定的仪表盘标签）
const MAX_TAGS = 20

// 固定标签：仪表盘（不可关闭）
const AFFIX_VIEW = {
  path: '/admin/dashboard',
  title: '仪表盘',
  componentName: 'AdminDashboard',
  affix: true
}

function loadPersistedViews() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const list = raw ? JSON.parse(raw) : []
    if (Array.isArray(list)) {
      const views = list.filter(v => v && v.path && v.title)
      // 旧数据超出上限时截断（保留固定标签在前）
      if (views.length > MAX_TAGS) {
        const affix = views.filter(v => v.affix)
        const normal = views.filter(v => !v.affix)
        views.length = 0
        views.push(...affix, ...normal.slice(0, MAX_TAGS - affix.length))
      }
      if (!views.some(v => v.affix)) {
        views.unshift({ ...AFFIX_VIEW })
      }
      return views
    }
  } catch (e) {
    // 解析失败时回退到默认
  }
  return [{ ...AFFIX_VIEW }]
}

function persist(views) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(views))
  } catch (e) {
    // 存储失败不影响功能
  }
}

export default {
  namespaced: true,
  state: {
    visitedViews: loadPersistedViews()
  },
  getters: {
    cachedViews: state => {
      const names = []
      state.visitedViews.forEach(v => {
        if (v.componentName && names.indexOf(v.componentName) < 0) {
          names.push(v.componentName)
        }
      })
      return names
    }
  },
  mutations: {
    ADD_VIEW(state, view) {
      if (!view || !view.path) return
      if (state.visitedViews.some(v => v.path === view.path)) return
      // 硬上限保护：超出不再新增（组件层负责提示）
      if (state.visitedViews.length >= MAX_TAGS) return
      state.visitedViews.push({ ...view })
      persist(state.visitedViews)
    },
    DEL_VIEW(state, path) {
      const idx = state.visitedViews.findIndex(v => v.path === path)
      if (idx >= 0 && !state.visitedViews[idx].affix) {
        state.visitedViews.splice(idx, 1)
        persist(state.visitedViews)
      }
    },
    DEL_OTHERS(state, path) {
      state.visitedViews = state.visitedViews.filter(v => v.affix || v.path === path)
      persist(state.visitedViews)
    },
    DEL_ALL(state) {
      state.visitedViews = state.visitedViews.filter(v => v.affix)
      persist(state.visitedViews)
    }
  }
}
